import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListCategoryFilters";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListCategoryFilters";

export default WidgetModule;
